import { cva } from "class-variance-authority";
import type { ComponentPropsWithRef, ElementRef } from "react";
import { forwardRef } from "react";
import { cn } from "../../helpers/styles";

type Props = Omit<ComponentPropsWithRef<"div">, "children"> & {
	children: React.ReactNode;
	type?: "regular" | "bold" | "success" | "error";
};

export const Tag = forwardRef<ElementRef<"div">, Props>(({ className, type, children }, ref) => (
	<div
		ref={ref}
		className={cn(
			tagVariants({
				type,
			}),
			className,
		)}
	>
		{children}
	</div>
));

Tag.displayName = "Tag";

const tagVariants = cva("inline-flex items-center justify-center px-md py-[3px] text-xs", {
	variants: {
		type: {
			regular: "rounded-sm border border-gray-300 bg-white font-medium text-gray-700",
			bold: "rounded-xxs bg-gray-600 font-bold text-white",
			success:
				"rounded-md border border-success-200 bg-success-50 px-[10px] py-xs text-sm font-medium text-success-700",
			error:
				"rounded-md border border-error-200 bg-error-50 px-[10px] py-xs text-sm font-medium text-error-700",
		},
	},
	defaultVariants: {
		type: "regular",
	},
});
